<div class="heading">
    <p>Republish Prompt</p>
</div>
<div class="instruction">
    <p class="mb-32">Are you sure you want to republish this prompt? It will be made available for use again.</p>
</div>
<div class="btn-container">
    <app-button [type]="'secondary'" [buttonType]="'button'" [buttonText]="'Cancel'" class="w-50 mr-12"
        (click)="cancelRepublish()"></app-button>
    <app-button [type]="'primary'" [buttonType]="'button'" [buttonText]="'Republish'" class="w-50"
        (click)="republishPrompt()"></app-button>
</div>